class MobileNav extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['menu-toggle', 'menu-item']
  }

  setupListeners () {
    super.setupListeners()

    this.els['menu-toggle'].elements.forEach(button => {
      button.addEventListener('click', this.menuToggle.bind(this))
    })
  }

  menuToggle (e) {
    const eventButton = e.target
    if (eventButton.getAttribute('aria-active') === 'true') return

    this.els['menu-toggle'].elements.forEach(button => {
      button.setAttribute('aria-active', button === eventButton ? 'true' : 'false')
    })

    this.els['menu-item'].elements.forEach(item => {
      const isHidden = item.getAttribute('aria-hidden') === 'true'
      item.setAttribute('aria-hidden', isHidden ? 'false' : 'true')
      item.setAttribute('hidden', isHidden ? 'false' : 'true')

      if (isHidden) {
        item.removeAttribute('hidden')
      }
    })

    if (this.els['promo'] === undefined) return

    this.els['promo'].elements.forEach(promo => {
      const isHidden = promo.getAttribute('aria-hidden') === 'true'
      promo.setAttribute('aria-hidden', isHidden ? 'false' : 'true')
      promo.setAttribute('hidden', isHidden ? 'false' : 'true')

      if (isHidden) {
        promo.removeAttribute('hidden')
      }
    })
  }
}

if (!customElements.get('mobile-nav')) {
  customElements.define('mobile-nav', MobileNav)
}
